// extracted by mini-css-extract-plugin
module.exports = {"content":"layout-module--content--2CPz1"};